import { createPersistedStore } from './createPersistedStore'

// Last Trip/Map tab the user picked in a load detail. Remembered across loads and
// browser sessions, so opening a new load (or re-expanding a row) lands on the tab
// they last used instead of always resetting to Trip. Shared by every load-detail
// surface (load-hub expanded row, agentic-hub, shared-load page) because the choice
// is a property of the view, not of one load — the same reason the tab lives in the
// component rather than per-row state.

type LoadDetailTab = 'trip' | 'map'

/** `[tab, setTab]`, like `useState`, but backed by a shared persisted store so the
 *  choice carries across loads and sessions rather than defaulting to Trip each time. */
export const useLoadDetailTab = createPersistedStore<LoadDetailTab>(
    'load_hub_detail_tab',
    (raw) => (raw === 'map' ? 'map' : 'trip'),
    (tab) => tab
)
